import getAll from './getAll'
import del from './delete'
import create from './create'
import get from './get'
import update from './update'
import download from './download'
import getAllWithTags from './getAllWithTags'
import trackView from './trackView'
import share from './share'
import getPublic from './getPublic'

export default host => ({
  getAll: getAll(host),
  delete: del(host),
  create: create(host),
  get: get(host),
  update: update(host),
  download: download(host),
  getAllWithTags: getAllWithTags(host),
  trackView: trackView(host),
  share: share(host),
  getPublic: getPublic(host),
})
